import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import clsx from 'clsx';
import { i18n } from '../../translate/i18n';
import * as actions from '../../store/actions';

import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExitToApp from '@mui/icons-material/ExitToApp';
import FaceIcon from '@mui/icons-material/Face';
import TranslateIcon from '@mui/icons-material/Translate';

import { makeStyles, useTheme } from '@mui/styles';
import { alpha } from '@mui/material/styles';
import withSession from '../../HOC/withSession';

import {
	CssBaseline,
  AppBar,
  Toolbar,
  MenuItem,
  Select,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Menu,
  Grid,
  Avatar,
} from '@mui/material';

import Usuario from '../Usuario';
import ListItems from './ListItems/ListItems';
import { roleNames, rolesText } from '../../utils/roleNames'
import { sortBy } from 'lodash';
import BlockedTenantDialog from './BlockedTenantDialog/blockedTenantDialog';

import geequipLOGO from '../../assets/Icone-png-16.png'
import { EquipmentsRegistrationLimitWarning } from '../EquipmentsRegistrationLimitWarning';
import { EquipmentsRegistrationLimitWarningModal } from '../EquipmentsRegistrationLimitWarningModal';

const drawerWidth = 240;

const NavLinkStyled = styled(NavLink)`
  color: #333;
  text-decoration: none;
`

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    // marginRight: theme.spacing(2),
    // marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      // marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 500,
    },
  },
  buttonNav: {
    color: 'white',
    margin: theme.spacing(1)
  },
  avatar: {
    width: 70,
    height: 70,
    cursor: 'pointer',
  },
  avatarSmall: {
    width: 45,
    height: 45,
    cursor: 'pointer',
  },
  avatarSmallText: {
    fontSize: '0.75rem',
    width: '2.75rem',
    height: '2.75rem',
    marginRight: '0.25rem',
    marginLeft: '0.25rem',
  },
  link: {
    textDecoration: 'none'
  },
  root: {
    display: 'flex',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  menuUserContainer: {
    color: '#fff',
    textAlign: 'left',
    fontSize: 12,
    textTransform: 'capitalize',
    // padding: '7.5px',
    // borderRadius: '5px',
    // cursor: 'pointer',
    // '&:hover': {
    //   backgroundColor: 'darkgreen',
    // },
  },
  navlink: {
    color: '#333',
    textDecoration: 'none',
  },
  cardBody: {
    display: "flex",
    justifyContent: "center",
    paddingLeft: 10,
    flexDirection: 'column',
  },
  nameText: {
    fontWeight: "bold"
  },
  roleText: {
    fontSize: 12
  },
  userButton: {
      '&:hover': {
        borderRadius: 0
      }
  },
  notActiveBadge: {
    position: 'absolute',
    top: 10,
    right: 10,
    backgroundColor: "#f44336",
    padding: "5px 10px",
    borderRadius: 10,
    fontSize: 12,
    color: "#fff",
    fontWeight: "bold"
  }
}));

function NavBar(props) {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectOpen, setSelectOpen] = useState(false);
  const [language, setLanguage] = useState(localStorage.getItem('i18nextLng'));
  const [openedBlockedTenantDialog, setOpenedBlockedTenantDialog] = useState(false);
  const selectedTenant = useSelector(state => state.auth.selectedAccess.tenant._id);
  const access = useSelector(state => state.auth.access);
  const superadmin = useSelector(state => state.auth.superadmin)
  const tenantBlocked = useSelector(state => state.auth.selectedAccess.tenant.blocked);

	const open = useSelector(state => state.drawer.open)

  const me = useSelector(state => state.auth)
  const profilePhoto = useSelector(state => state.auth.photo);

  function handleClickMenu(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  const signOut = () => {
    dispatch(actions.logout())
  }

  const fetchAllSitesByTenant = useCallback(
    () => dispatch(actions.fetchAllSitesByTenant(selectedTenant))
  );

  const fetchExpiredServicesBadge = useCallback(
    () => dispatch(actions.fetchExpiredServicesBadge())
  );

  const fetchEquipmentsCount = useCallback(() => dispatch(actions.fetchTenantEquipmentsCount()), [dispatch]);

  useEffect(() => {
    fetchAllSitesByTenant()
      .then(res => {
        if (res === 'success') {
          //reset selected for the ones user has
          dispatch(actions.defaultSiteSelectedPlaces(me.selectedAccess));
          dispatch(actions.defaultSiteSelectedQuestions(me.selectedAccess));
        }
      })
    fetchExpiredServicesBadge()
  }, [])

  useEffect(() => {
    setOpenedBlockedTenantDialog(tenantBlocked)
  }, [tenantBlocked])

  useEffect(() => {
    fetchEquipmentsCount();
  }, [])

  const handleOpen = () => {
    setSelectOpen(true);
  };

  const handleCloseSelect = (e) => {
    e.stopPropagation();
    setSelectOpen(false);
  };

  const handleChange = (event) => {
    setLanguage(event.target.value);
    localStorage.setItem('i18nextLng',event.target.value)
    window.location = window.location;
  };

  const handleCloseBlockedTenantDialog = () => {
    if (superadmin) {
      setOpenedBlockedTenantDialog(false)
    }
  }

  const selectTenantCard = (ac) => {
    if (ac.active === false) return;
    if (ac._id === 1) {
      props.history.push(`/tenants`)
    } else {
      localStorage.setItem('selectedTenant', ac.tenant._id);
      localStorage.setItem('access', ac._id);

      dispatch(actions.selectTenantAccess(ac))
      props.history.push(`/`)
    }
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <EquipmentsRegistrationLimitWarningModal />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}>
        <Toolbar style={styles.toolbar}>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={() => dispatch(actions.setOpenDrawer(true))}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
            size="large">
            <MenuIcon />
          </IconButton>
          <div style={styles.logoContainer} onClick={() => props.history.push('')}>
            <img src={geequipLOGO} style={styles.logo} />
            <div style={styles.titleContainer}>
              <Typography style={{ fontWeight: 'bold', fontSize: 22 }} className={classes.title} noWrap>ge</Typography>
              <Typography style={{ fontSize: 22 }}>equip</Typography>
            </div>
          </div>
          <EquipmentsRegistrationLimitWarning version="app-bar" />
          <div style={styles.buttonContainer}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button className={classes.menuUserContainer} onClick={handleClickMenu}>
                <div style={{ display: 'flex' }}>
                 {profilePhoto && profilePhoto.url ? <Avatar className={classes.avatarSmall} alt="Remy Sharp" src={profilePhoto && profilePhoto.url} /> :
                  <Avatar className={classes.avatarSmallText} alt="Remy Sharp">
                    FOTO
                  </Avatar>}
                  <div style={styles.menuUserLabelContainer}>
                    <div>{i18n.t('wellcome.phrase1')} {me.name.split(' ')[0]}</div>
                    <div>{roleNames(me.selectedAccess.role)}</div>
                  </div>
                </div>
              </Button>
            </div>
          </div>

          <Menu
            style={{ marginTop: '50px', padding: '10px' }}
            id="menu"
            keepMounted
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <Grid container justifyContent="center" spacing={2} style={{ padding: '10px 15px' }}>
              <Grid item>
              {profilePhoto && profilePhoto.url ? <Avatar className={classes.avatar} alt="Remy Sharp" onClick={() => { props.history.push('/minha-conta'); handleClose(); }} src={profilePhoto && profilePhoto.url} /> :
                  <Avatar className={classes.avatarSmallText} alt="Remy Sharp" onClick={() => { props.history.push('/minha-conta'); handleClose(); }}>
                    FOTO
                  </Avatar>}
              </Grid>
              <Grid item style={{ minWidth: '200px', maxWidth: '300px' }}>
                <Typography>{me.name}</Typography>
                <Typography style={{ fontWeight: 'bold' }}>{me.selectedAccess.tenant.name}</Typography>
                <Typography style={{ color: 'grey' }}>{roleNames(me.selectedAccess.role)}</Typography>
                { me.selectedAccess.role === 'contractor' && <Typography style={{ color: 'grey' }}>{'(' + (me.selectedAccess.company?.name || '') + ')'}</Typography>}
                {me.selectedAccess.inspector && <Typography sx={{ color: 'grey', fontSize: '14px' }}>{i18n.t('typographyFormParamUser.inspector')}</Typography>}
              </Grid>
            </Grid>
            <Divider />
            <List>
                {
                  access.length >= 1 &&
                  <>
                    {
                      sortBy(access.filter(ac => selectedTenant !== ac.tenant._id), [(ac) => ac.tenant.name]).map(ac => (
                        <NavLinkStyled className={classes.Styled} to={""} onClick={() => selectTenantCard(ac)} key={ac._id}>
                          <ListItem
                            button>
                            <ListItemIcon>{ac.tenant.photo ? <Avatar src={ac.tenant.photo.url} /> : <Avatar>LOGO</Avatar>}</ListItemIcon>
                              <div className={classes.cardBody}>
                                <span className={classes.nameText}>{ac.tenant.name}</span>
                                <span className={classes.roleText}>{rolesText(ac)}</span>
                              </div>
                              {ac.active === false && <span className={classes.notActiveBadge}>Não Ativado</span>}
                          </ListItem>
                        </NavLinkStyled>
                      ))
                    }
                  </>
                }
                {
                  superadmin && 
                    <NavLinkStyled to={"/tenants"} className={classes.navlink}>
                        <ListItem
                          button>
                          <ListItemIcon><Avatar>SA</Avatar></ListItemIcon>
                          <div className={classes.cardBody}>
                            <span className={classes.nameText}>Area de administração</span>
                            <span className={classes.roleText}>Super Administrador</span>
                          </div>
                        </ListItem>
                    </NavLinkStyled>
                }
                {(superadmin || access.filter(ac => selectedTenant !== ac.tenant._id).length >= 1) && <Divider />}
              <NavLinkStyled to={"/minha-conta"} onClick={handleClose}>
                <ListItem
                  button>
                  <ListItemIcon><FaceIcon /></ListItemIcon>
                  <ListItemText
                    primary={i18n.t('myAccount.label2')} />
                </ListItem>
              </NavLinkStyled>
              <NavLinkStyled to={""} onClick={ handleOpen}>
                <ListItem button>
                  <ListItemIcon><TranslateIcon /></ListItemIcon>
                  <Select
                    variant="standard"
                    labelId="demo-controlled-open-select-label"
                    id="demo-controlled-open-select"
                    open={selectOpen}
                    onClose={handleCloseSelect}
                    onOpen={handleOpen}
                    value={language}
                    onChange={handleChange}>
                    <MenuItem value={'pt-BR'}>Português</MenuItem>
                    <MenuItem value={'en-US'}>English</MenuItem>
                    <MenuItem value={'esp-ES'}>Español</MenuItem>
                  </Select>
                </ListItem>
              </NavLinkStyled>
              <NavLinkStyled to={"/login"} onClick={signOut}>
                <ListItem button>
                  <ListItemIcon><ExitToApp /></ListItemIcon>
                  <ListItemText primary={i18n.t('myAccount.label3')} />
                </ListItem>
              </NavLinkStyled>
            </List>
          </Menu>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={() => dispatch(actions.setOpenDrawer(false))} size="large">
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <EquipmentsRegistrationLimitWarning version="side-bar" />
        <BlockedTenantDialog open={openedBlockedTenantDialog} handleClose={() => handleCloseBlockedTenantDialog}/>
        <Divider />
        <ListItems />
      </Drawer>
      <main
        style={{ backgroundColor: 'rgb(255, 255, 255)' }}
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })} >
        <div className={classes.drawerHeader} />
        <Usuario />
      </main>
    </div >
  );
}

export default withSession(NavBar);

const styles = {
  toolbar: {
    display: 'flex',
    backgroundColor: 'green'
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
		cursor: 'pointer'
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 10
  },
  logo: {
    width: 36,
    marginRight: 10,
  },
  menuIcon: {
    position: 'absolute',
    right: '10px'
  },
  buttonContainer: {
    position: 'absolute',
    right: '10px',
  },
  menuUserLabelContainer: {
    marginLeft: 5,
  }
}
